// components/TermsModal.js
import { Dialog } from "@headlessui/react";
import React from "react";

export default function TermsModal({ isOpen, onClose }) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-40" aria-hidden="true" />

      {/* Centered Modal */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-xl bg-white rounded-xl shadow-xl p-6">
          <Dialog.Title className="text-xl font-bold mb-4">Terms & Conditions</Dialog.Title>
          
          <div className="text-sm text-gray-700 overflow-y-auto max-h-[60vh] space-y-2">
            <p>
              By using this service, you agree to our Terms & Conditions. You may not redistribute
              content, use influencer images for unauthorized commercial use, or violate image IP rights.
            </p>
            <p>
              All payments are final. Images are licensed for single-use within the StyleUAI platform unless otherwise approved.
            </p>
            <p>
              If you do not agree with these terms, please do not proceed with the purchase.
            </p>
          </div>

          <div className="mt-6 text-right">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            >
              Close
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
